'use strict'
/* 
* input[submit] id needs to be = addtocartbutton
* div id after submit needs to be = addtocarttext
* Legg inn sku for produkter som ikke blir sent til sverige
*/

const tg = 'IkkeSverige' // Tag to check for and then remove product and purchase possibility
const se = 'SE'
const buttontext = `
<p style="color: #e75179; font-size: 15px;">
Denna produkt kan inte skickas till Sverige.
</p>`
const checkoutText = `
<p style="color: #e75179; font-size: 15px; margin-top: -50px;">
Din varukorg innehåller produkter som vi inte skicka till Sverige. Ta bort dem från korgen och uppdatera den här sidan för att fortsätta.
</p>`
const removeskufromcart = [
'CED300621'
]



const remove = x => x.style.display = 'none'
const checksku = r => (arr, item) => r.reduce((b, i) => i === item.sku ? true : b, false) === true ? arr.concat(item.title) : arr
const removeHomePagePakker = () => document.getElementById('homepage-pakker') ? remove(document.getElementById('homepage-pakker')) : null


const removeProductListing = () => {
 let x = document.getElementsByClassName('product') 
 for(var i = 0; i < x.length; i++) {
   x[i].localName === 'li' ? removeProduct(x[i]) : null
 } 
}

const removeProduct = x => {
  if(x.dataset.tags){
  if(x.dataset.tags.indexOf(tg) != -1) {
   remove(x)
  }
  } else {
    if(x.dataset.object.indexOf(tg) != -1) {
     remove(x)
  	}
  }
}

const removeBuyButton = () => {
  if(window.hasOwnProperty('pageData')) {
  if(pageData.product != null && pageData.product.tags.indexOf(tg) != -1) {
    remove(document.getElementById('addtocartbutton'))
    document.getElementById('addtocarttext').innerHTML = buttontext
  	}
  }
}

const maybeDenyCheckout = () => {
  if(window.hasOwnProperty('cart')) { // run denycheckout
    let t = cart.items.reduce(checksku(removeskufromcart), [])
    t.length >= 1 ? denyCheckout(t) : console.log('fant ikke svensk sku')
  }
}
    

const denyCheckout = (t) => {
  console.log('deny checkout for ', t)
  let ny = document.createElement('div')
  ny.innerHTML = checkoutText
  document.getElementById('checkout').parentNode.replaceChild(ny, document.getElementById('checkout'))
  t.map(singleOutProduct)
}

const singleOutProduct = x => {
  let y = document.getElementsByClassName('cart__product-title')
  for(var i = 0; i < y.length; i++) {
    x === y[i].innerHTML ? specifyInvalidProduct(y[i]) : null
  }
}

const specifyInvalidProduct = (x) => {
  let notice = document.createElement('div')
  notice.innerHTML = buttontext
  x.parentNode.insertBefore(notice, x.nextSibling)
}

LocationUtil.getValidLocation(e => {
      if(e == se) {
      removeHomePagePakker()
      removeProductListing()
      removeBuyButton()
      maybeDenyCheckout()
    }
})

